module.exports = __webpack_public_path__ + "img/wxewm.7c9da12c.png";